__turbopack_context__.v({
  "appLayoutContentContainer": "[uid]-module-scss-module__AwsPdW__appLayoutContentContainer",
  "buttonLinkContainer": "[uid]-module-scss-module__AwsPdW__buttonLinkContainer",
  "gridContent": "[uid]-module-scss-module__AwsPdW__gridContent",
  "headerContainer": "[uid]-module-scss-module__AwsPdW__headerContainer",
  "imageContainer": "[uid]-module-scss-module__AwsPdW__imageContainer",
  "inlineContentContainer": "[uid]-module-scss-module__AwsPdW__inlineContentContainer",
  "linkContainer": "[uid]-module-scss-module__AwsPdW__linkContainer",
  "pageSectionContainer": "[uid]-module-scss-module__AwsPdW__pageSectionContainer",
  "standardContentContainer": "[uid]-module-scss-module__AwsPdW__standardContentContainer",
  "textContainer": "[uid]-module-scss-module__AwsPdW__textContainer",
});
